interface CustomerName {
  name?: string | null;
  last_name?: string | null;
}

// Los apellidos llegan asteriscados y pueden faltar: se muestran tal cual,
// sin dejar "null" ni "undefined" visibles ni espacios sobrantes
export const getCustomerFullName = (customer?: CustomerName | null): string => [
  customer?.name,
  customer?.last_name,
]
  .map((value) => value?.trim())
  .filter(Boolean)
  .join(' ');
